export const SWITCH_CHANGE = 'SWTICH_CHANGE';

export const switchChange = () => ({
  type: SWITCH_CHANGE,
});

export const noobModeChange = () => (dispatch) => {
  dispatch(switchChange());
};
